import React, {ReactNode} from 'react';
import {StyleProp, StyleSheet, TextStyle} from 'react-native';

import Text from '../Text';

type Props = {
  children: ReactNode;
  style?: StyleProp<TextStyle>;
};

const ValidationMessage = ({children, style}: Props) => (
  <Text style={[styles.main, style]}>{children}</Text>
);

const styles = StyleSheet.create({
  main: {
    fontSize: 12,
    fontWeight: '400',
    color: 'red',
    marginTop: 4,
    marginBottom: 8,
  },
});

export default ValidationMessage;
